import { render, staticRenderFns } from "./SceltaTema.vue?vue&type=template&id=67691f1c&scoped=true"
import script from "./SceltaTema.vue?vue&type=script&lang=js"
export * from "./SceltaTema.vue?vue&type=script&lang=js"
import style0 from "./SceltaTema.vue?vue&type=style&index=0&id=67691f1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67691f1c",
  null
  
)

export default component.exports